import transformStyle from 'rtl-css-js';

export default function rtl() {
  return function (style) {
    return transformStyle(style);
  };
}